document.addEventListener('cart:updated', () => {
  fetch('/?sections=cart-drawer')
    .then((res) => res.json())
    .then((data) => {
      const parser = new DOMParser();
      const html = parser.parseFromString(data['cart-drawer'], 'text/html');

      const newDrawer = html.querySelector('cart-drawer');
      const currentDrawer = document.querySelector('cart-drawer');

      if (newDrawer && currentDrawer) {
        currentDrawer.innerHTML = newDrawer.innerHTML;

        // Opcional: volver a iniciar eventos si los tenés en JavaScript externo
        document.dispatchEvent(new Event('cart:drawer:reloaded'));
      }
    });
});
